export default "__VITE_ASSET__kfJ3ANAL__"